import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
  NbToggleModule,
  NbCardModule,
  NbDialogModule,
  NbSpinnerModule,
  NbInputModule,
  NbToastrModule,
  NbTooltipModule,
  NbPopoverModule,
  NbListModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';

import {
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
  TinyMCEComponent,
  AgendaCompromissosComponent,
  AssistenteVirtualComponent,
  MostrarTutorialModule,
} from './components';
import { NotificacoesComponent } from './components/notificacoes/notificacoes.component';
import { ChatExecutivoOperacionalComponent } from './components/chat-executivo-operacional/chat-executivo-operacional.component';
import { AlertaChatOperacionalComponent } from './components/alerta-chat-operacional/alerta-chat-operacional.component';
import { MaintenanceBannerComponent } from './components/maintenance-banner/maintenance-banner.component';
import { TutorialOverlayComponent } from './components/header/components/agenda-compromissos/tutorial-overlay/tutorial-overlay.component';
import { TermometroDataFechamentoComponent } from './components/header/components/termometro-data-fechamento/termometro-data-fechamento.component';
import { ModalCompromissoCustomizadoComponent } from './components/header/components/agenda-compromissos/modal-compromisso-customizado/modal-compromisso-customizado.component';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { DARK_THEME } from './styles/theme.dark';


const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbToggleModule,
  NbCardModule,
  NbTooltipModule,
  NbPopoverModule,
  NbListModule,
  NbDialogModule.forChild(),
  NbSpinnerModule,
  NbInputModule,
  NbToastrModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  TinyMCEComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  AgendaCompromissosComponent,
  TutorialOverlayComponent,
  ModalCompromissoCustomizadoComponent,
  NotificacoesComponent,
  ChatExecutivoOperacionalComponent,
  AlertaChatOperacionalComponent,
  AssistenteVirtualComponent,
  MaintenanceBannerComponent,
  TermometroDataFechamentoComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
];

@NgModule({
  imports: [CommonModule, FormsModule, RouterModule, ...NB_MODULES, MostrarTutorialModule],
  exports: [CommonModule, FormsModule, RouterModule, ...PIPES, ...COMPONENTS, MostrarTutorialModule],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'corporate',
          },
          [ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME ],
        ).providers,
        ...NbDialogModule.forRoot().providers,
      ],
    };
  }
}
